import { createContext, ReactNode, useContext, useMemo, useState } from 'react';

import { TWagon, TWagonSeat } from '../domains/buy-ticket/types';

type WagonDataProviderProps = {
  direction: 'forward' | 'backward';
  seats: TWagon['seats'];
  disabled: boolean;
  children: ReactNode;
  onChange?: (seats: number[]) => void;
};

type CtxType = {
  direction: 'forward' | 'backward';
  disabled: boolean;
  seatsMap: Map<number, TWagonSeat>;
  onSeatClick: (seat: number) => void;
};

export const Context = createContext<CtxType | null>(null);

export const useWagonData = () => useContext(Context);

export const WagonDataProvider = ({
  direction,
  seats,
  disabled = false,
  onChange,
  children,
}: WagonDataProviderProps) => {
  const [selectedSeats, setSelectedSeats] = useState<number[]>([]);
  const seatsMap = useMemo(() => {
    const sMap = new Map<number, TWagonSeat>();
    seats.forEach((seat) => {
      sMap.set(seat.number, seat);
    });

    return sMap;
  }, [seats]);
  const onSeatClick = (seat: number) => {
    const newSelectedSeats = selectedSeats.includes(seat)
      ? selectedSeats.filter((s) => s !== seat)
      : [...selectedSeats, seat];
    setSelectedSeats(newSelectedSeats);
    onChange?.(newSelectedSeats);
  };

  return (
    <Context.Provider value={{ direction, seatsMap, disabled, onSeatClick }}>
      {children}
    </Context.Provider>
  );
};
